export const getBlogEp = () =>
  (`/api/blog`);


export const blogEndpoints = {
  all: () => `/api/blog`,
  single: (id: string) => `/api/blog/${id}`,
  add: () => `/api/blog`,
  update: (id: string) => `/api/blog/${id}`,
  delete: (id: string) => `/api/blog/${id}`
};
